module.exports = __webpack_public_path__ + "img/used1.a136b45e.png";